module.exports = __webpack_public_path__ + "media/images/arrow_left-078cf237.svg";